import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NoData from '@/components/NoData/NoData';
import AddConfig from '@/components/System/globalcofig/addcofig';
import { valsubstr32addbr } from '@/utils/index';
import { getSystemInnerList } from '@/api/message';
export default {
  components: {
    NoData: NoData,
    AddConfig: AddConfig
  },
  data: function data() {
    return {
      ConfigData: [],
      configuredSyslist: [],
      loading: false,
      tableheight: 512,
      activeName: 'first',
      notaddsystem: true,
      showaddcofig: false,
      optionallist: [],
      configval: '',
      dialogtitle: '',
      iseditconfig: false,
      configid: 0,
      // 配置的ID
      configvalueid: 0,
      // 配置值的ID
      canaddsystemlist: [],
      allsystemlist: [],
      configvaluekey: ''
    };
  },
  created: function created() {
    this.configuredSys();
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 332;
      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 332;
      };
    });
  },
  methods: {
    configuredSys: function configuredSys() {
      var _this = this;
      this.$API.getRequest({
        url: '/platform/global/config/configuredSys'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this.configuredSyslist = res.result;
          _this.activeName = res.result[0] ? res.result[0].systemId : '';
          _this.getconfigofsys();
        }
      });
    },
    getconfigofsys: function getconfigofsys() {
      var _this2 = this;
      this.$API.getRequest({
        url: '/platform/global/config',
        data: {
          systemId: this.activeName
        }
      }).then(function (res) {
        // eslint-disable-next-line no-return-assign
        res.result.filter(function (item) {
          return item.edited = true;
        });
        _this2.ConfigData = res.result;
      });
    },
    getconfigoptional: function getconfigoptional() {
      var _this3 = this;
      this.$API.getRequest({
        url: '/platform/global/config/optional',
        data: {
          systemId: this.activeName
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.optionallist = res.result;
        }
      });
    },
    // 新增配置的系统
    addsystem: function addsystem() {
      if (this.configuredSyslist.length === 0) {
        this.showaddcofig = true;
        this.dialogtitle = '新增子系统配置';
        this.iseditconfig = false;
        this.notaddsystem = false;
        if (this.allsystemlist.length === 0) {
          this.getsystemlist();
        } else {
          this.filtratesystem();
        }
        return;
      }
      // 是否已经添加完所有选项
      if (this.configuredSyslist.length === this.allsystemlist.length) {
        this.$message({
          message: '已无可添加配置的系统',
          type: 'warning'
        });
      } else {
        this.showaddcofig = true;
        this.dialogtitle = '新增子系统配置';
        this.iseditconfig = false;
        this.notaddsystem = false;
        if (this.allsystemlist.length === 0) {
          this.getsystemlist();
        } else {
          this.filtratesystem();
        }
      }
    },
    // 获取可选系统的列表
    getsystemlist: function getsystemlist() {
      var _this4 = this;
      getSystemInnerList().then(function (res) {
        var code = res.code,
          result = res.result;
        if (code === '0000000000') {
          _this4.allsystemlist = result.records;
          _this4.filtratesystem();
        }
      });
    },
    // 筛选可添加系统
    filtratesystem: function filtratesystem() {
      var _this5 = this;
      this.canaddsystemlist = [];
      var haveconfigsys = [];
      this.configuredSyslist.filter(function (item) {
        return haveconfigsys.push(item.systemId);
      });
      // eslint-disable-next-line array-callback-return
      this.allsystemlist.filter(function (item) {
        if (!haveconfigsys.includes(item.systemId)) {
          _this5.canaddsystemlist.push(item);
        }
      });
    },
    // 新增可全局配置的系统
    AddconfigsystemFn: function AddconfigsystemFn(obj) {
      this.configuredSyslist.push(obj.system);
      // if(this.configuredSyslist == 1){

      // }
      this.showaddcofig = false;
    },
    // 新增||修改配置
    AddconfigSubmitFn: function AddconfigSubmitFn(obj) {
      var _this6 = this;
      // console.log(obj.formData,"aaaaaaaaaaaaaaa")
      if (obj.bool) {
        obj.formData.systemId = this.activeName;
        if (this.iseditconfig) {
          obj.formData.id = this.configid;
          obj.formData.value.id = this.configvalueid;
          this.$API.putRequest({
            url: '/platform/global/config/',
            data: obj.formData
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this6.$message({
                message: '修改配置成功',
                type: 'success'
              });
              _this6.getconfigofsys();
              _this6.showaddcofig = false;
            }
          });
        } else {
          this.$API.postRequest({
            url: '/platform/global/config/',
            data: obj.formData
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this6.$message({
                message: '新增配置成功',
                type: 'success'
              });
              _this6.getconfigofsys();
              _this6.showaddcofig = false;
            }
          });
        }
      } else {
        this.showaddcofig = false;
      }
    },
    handleClick: function handleClick() {
      this.getconfigofsys();
    },
    addcofig: function addcofig() {
      this.showaddcofig = true;
      this.configval = '';
      // if(this.optionallist.length == 0 ){
      this.getconfigoptional();
      // }
      this.dialogtitle = '新增配置';
      this.iseditconfig = false;
      this.notaddsystem = true;
    },
    // 编辑配置
    editconfig: function editconfig(obj) {
      // this.$refs[`config-`+obj.row.id].doClose()
      this.showaddcofig = true;
      this.dialogtitle = '修改配置';
      // if(this.optionallist.length == 0 ){
      this.getconfigoptional();
      // }
      this.iseditconfig = true;
      this.notaddsystem = true;
      this.configval = obj.row.bindDictCode;
      this.configid = obj.row.id;
      this.configvalueid = obj.row.value.id;
      this.configvaluekey = obj.row.value.configValue;

      // this.dialogtitle = '新增子系统配置'
      // this.$set(obj.row, "isedit", true)
    },
    // 删除
    confirmdel: function confirmdel(obj, bool) {
      var _this7 = this;
      if (bool) {
        this.$refs["config-".concat(obj.row.id)].doClose();
        this.$API.delRequest({
          url: "/platform/global/config/".concat(obj.row.id)
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this7.$message({
              message: '删除配置成功',
              type: 'success'
            });
            _this7.getconfigofsys();
          }
        });
      }
    },
    getsystemname: function getsystemname(val) {
      var systemname = '';
      // eslint-disable-next-line array-callback-return
      this.configuredSyslist.filter(function (item) {
        if (item.systemId === val) {
          systemname = item.systemName;
        }
      });
      return systemname;
    },
    // tooltips过长换行(length 32换行)
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    }
  }
};